<template>
  <div>
    <bankChannelTab>
      <template v-slot="{ channelType }">
        <div>
          <base-list-management v-if="channelType === bankChannelType" ref="baseListManagement"
            :configData.sync="configData">
          </base-list-management>
          <!-- 全部提现二次弹窗 -->
          <dialogWrap v-model="confirmDialog.show" title="请二次确认" width="500px">
            <div>
              {{ `您将提现 ${confirmDialog.merchantName} 下的所有余额 ${bankChannelType === 6 ? '（含冻结待分账金额）' : ''}，是否确定？` }}</div>
            <template slot="footer">
              <el-button size="small" @click="confirmDialog.show = false">取消</el-button>
              <el-button size="small" :loading="confirmDialog.loading" type="primary"
                @click="submitConfirmHandle">确认</el-button>
            </template>
          </dialogWrap>
          <bindBankCard ref="bindBankCardRef" v-if="channelType === bankChannelType" @updateList="updateList" />
          <!-- 支付宝支付申请开通相关组件 -->
          <openAlipayWithholdProtocolDialog
            ref="protocolRef"
            @agreeToContinueOpen="agreeToContinueOpen"
          />
          <openAliPayWithholdConfig
            ref="alipayWithholdConfigRef"
            @refreshList="updateList"
          />
        </div>
      </template>
    </bankChannelTab>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { withdrawSubAccountBalance } from '@/api/domain/finance'
import openAlipayWithholdProtocolDialog from './components/openAlipayWithholdProtocolDialog.vue'
import bankChannelTab from '@/pages/finance/bankChannelTab'
import { mapGetters } from 'vuex'
import bindBankCard from './components/bindCardDrawer/index.vue'
import openAliPayWithholdConfig from './components/openAliPayWithholdConfig.vue'
import config from './components/pingAnBankWalletWithholdConfig/mixins/config'
import PingAnBankConfigMixin from './components/pingAnBankWalletWithholdConfig/mixins/pingAnBankConfigMixin'

export default {
  components: {
    bankChannelTab,
    bindBankCard,
    openAlipayWithholdProtocolDialog,
    openAliPayWithholdConfig,
  },
  mixins: [PingAnBankConfigMixin, config],
  data() {
    return {
      confirmDialog: {
        show: false,
        loading: false,
        accountId: 0,
        merchantName: '',
      },
    }
  },
  mounted() {
    this.configData.formData.formProps.model.channelType = this.bankChannelType
  },
  computed: {
    ...mapGetters(['bankChannelType']),
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    addMainAccount() {
      this.$refs.AddMainAccount.dialogVisible = true
    },
    // 刷新列表 ../mixins/pingAnBankConfigMixin.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    refreshTable() {
      this.$refs.baseListManagement.searchForm()
    },
    // 全部提现弹窗
    // eslint-disable-next-line vue/no-unused-properties
    withDrawBalance(row) {
      this.confirmDialog = {
        show: true,
        accountId: row.accountId,
        merchantName: row.merchantName,
      }
    },
    // 确认全部提现
    async submitConfirmHandle() {
      this.confirmDialog.loading = true
      try {
        const { code, data } = await withdrawSubAccountBalance({
          accountId: this.confirmDialog.accountId,
          channelType: this.bankChannelType,
        })

        this.confirmDialog.loading = false

        if (code === 1) {
          this.confirmDialog.show = false
          if (data.result) {
            this.$message.success('提现申请已提交')
          } else {
            this.$message.error(data.info)
          }
        }
      } catch (error) {
        this.confirmDialog.loading = false
      }
    },
    // mode: bind, change
    // eslint-disable-next-line vue/no-unused-properties
    bindCard(row, mode) {
      this.$refs.bindBankCardRef.openDrawer(row, mode)
    },
    updateList() {
      this.$refs.baseListManagement.searchForm()
    },
    // 申请开通支付宝支付，config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    openAlipayWithhold(row) {
      this.$refs.protocolRef.showDialog(row)
    },
    // 同意继续开通
    agreeToContinueOpen(row) {
      this.$refs.alipayWithholdConfigRef.showDialog(row)
    },
  },
  watch: {
    bankChannelType: {
      handler(val) {
        this.configData.formData.formProps.model.accountId = ''
        this.configData.formData.formProps.model.channelType = val
      },
    },
  },
}
</script>
